import { PencilLine } from "lucide-react";

/* Master-account shortcut: edit pricing, paper, options right from the storefront page. */
export function OwnerEditButton({ user, onClick }) {
  if (!user?.is_owner) return null;
  return (
    <button type="button" onClick={onClick} data-testid="owner-edit-product"
      className="mb-3 inline-flex items-center gap-2 px-3 py-1.5 bg-kolt-slate-dark text-white font-mono text-[10px] tracking-[0.22em] uppercase font-bold hover:bg-kolt-orange transition-colors">
      <PencilLine className="w-3.5 h-3.5" /> Edit product
    </button>
  );
}
